
import { RevIllustration } from '@ds/components/Illustration'
import { RevModal } from '@ds/components/Modal'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'

import translationsTrustList from '../TrustList/TrustList.translations'

import WarrantyModalContent from './WarrantyModalContent.vue'

export default {
  components: {
    RevIllustration,
    RevModal,
    WarrantyModalContent,
  },

  props: {
    name: {
      type: String,
      default: MODAL_NAMES.REASSURANCE.WARRANTY,
    },
    warranty: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      warrantyDuration: 'config/warrantyDuration',
    }),

    title() {
      if (!isEmpty(this.warranty)) {
        return this.warranty
      }

      return this.$t(translationsTrustList.warranty, {
        warrantyDuration: this.warrantyDuration,
      })
    },
  },
}
